
import React from 'react';
import {
  Introduction,
  EvolutionOfITNeeds,
  SupportModels,
  GrowthStages,
  TransitionIndicators,
  SuccessfulTransition,
  Conclusion
} from './index';

const ITSupportModel: React.FC = () => {
  return (
    <>
      <Introduction />
      <EvolutionOfITNeeds />
      <SupportModels />
      <GrowthStages />
      <TransitionIndicators />
      <SuccessfulTransition />
      <Conclusion />
    </>
  );
};

export default ITSupportModel;
